/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import {
  ButtonPrimary,
  CardInfoboxChip,
  CardSupport,
  ScrollToTop,
  ButtonCancelActivation,
  Ta11yText
} from '@core/index';
import { TariffSliderAccessible } from '@part/Tariff';
import { appButtonType, appCardStyle, appIconsPath, appInfoCardSize } from '@utils/globalConstant';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { useStaticContent } from '@dom-digital-online-media/dom-static-content-sdk';

export function MultiTariff() {
  const scrollRef = useRef(null);

  // Contexts
  const {
    isLoading,
    bookableTariffs,
    setTariffActivationForm,
    tariffActivationForm,
    setStep2SubStep,
    setShowActivationCancelModal
  } = useActivation();
  const { staticContentData } = useStaticContent();
  const { tA11yTranslate } = useA11y();

  // States
  const [selectedTariff, setSelectedTariff] = useState(null);
  const [selectedTariffId, setSelectedTariffId] = useState(null);
  const [image, setImage] = useState('');

  const buttonContent = tA11yTranslate('ek_reg_tariff-upsell_btn1');
  const tariffNameFull = `${tA11yTranslate(tariffActivationForm.chosenTariffName).content}\u00A0${
    tA11yTranslate(tariffActivationForm.chosenTariffSpeed).content
  }`;

  // Hooks
  useEffect(() => {
    if (selectedTariffId) {
      const selected = bookableTariffs.find((tariff) => `${tariff.id}` === selectedTariffId);
      setSelectedTariff(selected);
    }
  }, [selectedTariffId]);

  useEffect(() => {
    if (staticContentData && staticContentData.media_image) {
      const findImage = staticContentData.media_image.find(
        (item) => item.image_ref === 'ek_app_reg_tariff-upsell_content-1'
      );
      if (findImage) setImage(findImage);
    }
  }, [staticContentData]);

  // UNCOMMENT if needed
  // scroll to the referenced element when the component mounts
  // useEffect(() => {
  //   if (scrollRef.current) {
  //     scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }, []);

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper isDefaultPadding={false}>
            <div className="row justify-content-center pt-40">
              <div className={`col-6 ${!image && 'bg-ek-midblue'}`}>
                <img
                  className="img-fluid object-fit-cover"
                  src={image.media_url_display}
                  alt={image.alt_text}
                />
              </div>
              <div className="col-12 my-40">
                <CardInfoboxChip
                  cardStyle={appCardStyle.SECONDARY}
                  cardSize={appInfoCardSize.DEFAULT}
                  chipIcon={appIconsPath.STAR}
                  chipLabel="ek_reg_tariff-upsell_hdl1"
                  text="ek_reg_tariff-upsell_txt1"
                />
              </div>
              {/* <div ref={scrollRef}> */}
              <Ta11yText
                tag="h2"
                textContent={tA11yTranslate('ek_reg_tariff-upsell_hdl2')}
                className="text-primary m-0"
              />
              {/* </div> */}
            </div>
          </AppPageContentWrapper>
          <div className="row justify-content-center w-100">
            <div className="col-lg-12 ps-40">
              <TariffSliderAccessible
                bookableTariffs={bookableTariffs}
                setTariffActivationForm={setTariffActivationForm}
              />
            </div>
          </div>
          <AppPageContentWrapper isDefaultPadding={false}>
            <div className="row justify-content-center pb-80">
              <div className="col-lg-8 col-10 px-0 mx-auto">
                <ButtonPrimary
                  buttonClass="my-40"
                  buttonType={appButtonType.PRIMARY}
                  buttonContent={replaceDynamicCmsContent(
                    buttonContent,
                    '{FULL_TARIFF_NAME}',
                    tariffNameFull
                  )}
                  isLoading={isLoading}
                  iconRight={appIconsPath.ARROW_RIGHT}
                  onClick={() => {
                    setSelectedTariffId(tariffActivationForm.chosenTariffId);
                    setStep2SubStep(1);
                  }}
                />
              </div>
              <CardSupport />
              <div className="d-flex justify-content-center mt-32">
                <ButtonCancelActivation />
              </div>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default MultiTariff;
